<template>
  <layout-vertical>
    <router-view v-if="$route.meta.noAnimation" />
    <transition
      v-else
      name="fade"
    >
      <router-view />
    </transition>
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'

export default {
  components: {
    LayoutVertical,
  },
}
</script>
